import { RootState } from '../../../store';
import { NavbarState } from './reducer';

interface State extends RootState {
  navbar: NavbarState;
}

export type Navbar = State['navbar'];

export const navbarSelector = ({ navbar }: State): Navbar => navbar;